import { TComponentName } from "../../types/common/components.types";
import { TContainerName } from "../../types/containers/XContainers.types";
import { TElementName } from "../../types/elements/XElement.types";

type TComponentReadableName = { [componentName in TComponentName]: string };

export const COMPONENT_READABLE_NAME: TComponentReadableName = {
  XPage: "Page",
  XHeader: "En tete",
  XFooter: "Pied de Page",
  XArticle: "Article",

  // CONTAINERS
  XStack: "Groupe",
  XGrid: "Grille",
  XCarousel: "Carousel",
  XCategoryFilter: "Filtre de Categorie",
  XProductDetails: "Detail de Produit",

  // ELEMENT
  XText: "Texte",
  XButton: "Bouton",
  XLink: "Lien",
  XImage: "Image",
  XBreadcrumb: "Hierachie",
  XCategoryList: "Liste de Categorie",
  XColorPicker: "Selectionneur de Couleur",
  XForm: "Formulaire",
  XOptionChoice: "Liste de Choix",
  XPricing: "Prix",
  XRating: "Notes",
  XMap: "Carte Google",
  XIcon: "Icone",
  XSearch: "Recherche",
};

export const CONTAINERS_NAME: TContainerName[] = [
  "XStack",
  "XGrid",
  "XCarousel",
  "XHeader",
  "XFooter",
  "XArticle",
];

export const ELEMENTS_NAME: TElementName[] = [
  "XText",
  "XButton",
  "XLink",
  "XImage",
  "XBreadcrumb",
  "XCategoryList",
  "XColorPicker",
  "XForm",
  "XOptionChoice",
  "XPricing",
  "XRating",
  "XCategoryFilter",
  "XProductDetails",
];
